import { Component, EventEmitter, Input, OnInit, Output, QueryList, SimpleChanges, TemplateRef, ViewChild, ViewChildren } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { AppState } from '@app/reducers';
import { CURRENT_YEAR_TO_NEXT_FIFTY_YEARS, CommonPaginationConfig, CrudType, CustomDirectiveConfig, DATE_FORMAT_TYPES, HttpCancelService, IPatchTableFilteredFields, NO_DATA_FOUND_MESSAGE, OtherService, RxjsService, SharedTableFilteredDataCreated, adjustDateFormatAsPerPCalendar, createOrUpdateFilteredFieldKeyValues, debounceTimeForDeepNestedObjectSearchkeyword, patchPersistedNgrxFieldValuesToForm, prepareReusablePTableLoadDataConfiguration, tableFilteredDataSelector$ } from '@app/shared';
import { TableFilterFormService } from '@app/shared/services/create-form.services';
import { MomentService } from '@app/shared/services/moment.service';
import { Store } from '@ngrx/store';
import { Table } from 'primeng/table';
import { combineLatest, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, take } from 'rxjs/operators';
@Component({
  selector: 'app-page-list-table',
  templateUrl: './page-list-table.component.html',
  styleUrls: ['./page-list-table.component.scss']
})
export class PageListTableComponent implements OnInit {
  searchForm: FormGroup;
  columnFilterForm: FormGroup;
  searchColumns: any;
  isAStringOnly = new CustomDirectiveConfig({ isAStringOnly: true });
  today = new Date();
  row: any = {};
  DATE_FORMAT_TYPES = DATE_FORMAT_TYPES;
  @Input() tabsList;
  @Input() selectedRows;
  @Input() status;
  @Input() activeList;
  @Input() totalRecords;
  @Input() loading;
  @Input() pageLimit;
  @Input() dataList: any;
  @Input() isShowNoRecord = true;
  @Input() isShowTotalRecord = false;
  @Input() responsive = true;
  @Input() selectedTabIndex = 0;
  @Input() reset = false;
  @Input() first = 0;
  @Input() pageSize = 10;
  @Input() isLazy: boolean = true;
  @Input() searchFirst: boolean;
  @Input() isSelectionOne: boolean;
  @Input() customScroll: boolean = true;
  @Input() scrollHeight: string = "327px";
  @Input() clearSelectedRow: boolean = false;
  @Output() onActionSubmited = new EventEmitter<any>();
  @Output() excelPrinted = new EventEmitter<any>();
  @Output() onSelectedRows = new EventEmitter<any>();
  @Output() onSelectRow = new EventEmitter<any>();
  @Output() onUnSelectRow = new EventEmitter<any>();
  @Input() menuItems;
  @Input() menudownloadItems;
  @Input() enableFieldValuesPersistance = false;
  @Input() alwaysShowPaginator = true;
  @Input() templateRefOne: TemplateRef<any>;
  @Input() templateRefTwo: TemplateRef<any>;
  @Input() showSelectAllCheckbox = true;
  @ViewChild('dt', { static: false }) table: Table;
  @ViewChildren(Table) tables: QueryList<Table>;
  showPickedOrdersPopup = false;
  selectedriIndex: any;
  // start logic table fields search persistant
  tableFilteredFields: any = {};
  areColumnFiltersEdited = false;
  isPaginationRequested = false;
  isSortingRequested = false;
  // end logic table fields search persistant
  NO_DATA_FOUND_MESSAGE = NO_DATA_FOUND_MESSAGE;
  event;
  isSaveFilterBtnDisabled = false;
  isClearFilterBtnDisabled = false;
  scrollTableHeaderData: any;
  scrollTableBodyData: any;

  constructor(private _fb: FormBuilder, private tableFilterFormService: TableFilterFormService, private store: Store<AppState>, private router: Router,
    private momentService: MomentService, private otherService: OtherService, private rxjsService: RxjsService, private httpCancelService: HttpCancelService) {
    this.searchForm = this._fb.group({ searchKeyword: "" });
    this.columnFilterForm = this._fb.group({});
  }

  ngOnInit(): void {
    console.log('totalRecords', this.totalRecords)
    this.columnFilterForm = this.tabsList?.length ? this.tableFilterFormService.createFormGroup(this.tabsList[this.selectedTabIndex]?.columns) : this.columnFilterForm;
    this.searchKeywordRequest();
    this.columnFilterRequest();
    if (this.enableFieldValuesPersistance) {
      // start logic table fields search persistant
      combineLatest([
        // Little trick is added to validate and retrieve the field searches across the multiple tab based tables
        this.rxjsService.getAnyPropertyValue(),
        this.store.select(tableFilteredDataSelector$)
      ]).subscribe((observables) => {
        if (Object.keys(observables[0] ? observables[0] : {}).length > 0) {
          this.areColumnFiltersEdited = false;
          this.isPaginationRequested = false;
          this.isSortingRequested = false;
        }
        if (!observables[1]) return;
        this.tableFilteredFields = observables[1];
        // Give some milliseconds to render with proper history of fields search values and table results
        setTimeout(() => {
          this.otherService.currentUrl = this.otherService.currentUrl ?
            this.otherService.currentUrl : this.router.url;
          // If the key value pair is about to be created for the first time
          if (Object.keys(this.tableFilteredFields?.[this.otherService.currentUrl] ?
            this.tableFilteredFields[this.otherService.currentUrl] : {}).length == 0) {
            if (this.areColumnFiltersEdited || this.isSortingRequested || this.isPaginationRequested) {
              this.httpCancelService.cancelPendingRequestsOnFormSubmission();
            }
            this.onCRUDRequested(CrudType.GET, this.returnRowObjectWithIndexKey(), null, false);
          }
          // If the key value pair is created already with existed searched filters
          else if (Object.keys(this.tableFilteredFields?.[this.otherService.currentUrl] ?
            this.tableFilteredFields[this.otherService.currentUrl] : {}).length > 2) {
            this.organizeRowVariableAsPerTabIndex();
            // Helps to persist the previously searched results and field values
            let { columnFilterForm, row }: IPatchTableFilteredFields = patchPersistedNgrxFieldValuesToForm(this.columnFilterForm, this.tableFilteredFields, this.router,
              this.otherService, this.httpCancelService, this.areColumnFiltersEdited, this.isPaginationRequested, this.isSortingRequested);
            this.row[this.selectedTabIndex ? this.selectedTabIndex : 0] = row;
            this.columnFilterForm = columnFilterForm;
            this.httpCancelService.cancelPendingRequestsOnFormSubmission();
            this.onCRUDRequested(CrudType.GET, this.returnRowObjectWithIndexKey(), null, false);
          }
          // If the key value pair is created for the pageIndex and pageSize alone
          else if (Object.keys(this.tableFilteredFields?.[this.otherService.currentUrl] ?
            this.tableFilteredFields[this.otherService.currentUrl] : {}).length == 2) {
            this.row[this.selectedTabIndex ? this.selectedTabIndex : 0] = this.tableFilteredFields[this.otherService.currentUrl];
            this.httpCancelService.cancelPendingRequestsOnFormSubmission();
            this.onCRUDRequested(CrudType.GET, this.returnRowObjectWithIndexKey(), null, false);
          }
        });
      });
      // end logic table fields search persistant
    }
  }

  getYearRange() {
    return CURRENT_YEAR_TO_NEXT_FIFTY_YEARS;
  }

  getDateFormat() {
    return adjustDateFormatAsPerPCalendar();
  }

  onPageChange(e) {
    this.isPaginationRequested = true;
    this.isSortingRequested = false;
    this.areColumnFiltersEdited = false;
    if (this.enableFieldValuesPersistance) {
      // if first has greater than 0 then some pagination user action is done
      this.areColumnFiltersEdited = false;
      setTimeout(() => {
        this.row[this.selectedTabIndex ? this.selectedTabIndex : 0] = prepareReusablePTableLoadDataConfiguration(this.tableFilteredFields, this.otherService, this.router,
          this.areColumnFiltersEdited, this.isPaginationRequested, this.isSortingRequested, this.event);
        this.onCRUDRequested(CrudType.GET, this.returnRowObjectWithIndexKey(), null, true, false);
      }, 100);
    }
  }

  onSortChange(e) {
    if (this.enableFieldValuesPersistance) {
      this.onScrollTableScrollbar();
      let filteredObject = this.tableFilteredFields?.[this.otherService?.currentUrl];
      if (filteredObject?.sortOrderColumn !== e.field ||
        (filteredObject?.sortOrder == 'ASC' ? 1 :
          filteredObject?.sortOrder == 'DESC' ? -1 : 0) !== e.order) {
        this.isSortingRequested = true;
      }
      this.isPaginationRequested = false;
      this.areColumnFiltersEdited = false;
      // if first has greater than 0 then some pagination user action is done
      this.areColumnFiltersEdited = false;
      setTimeout(() => {
        this.row[this.selectedTabIndex ? this.selectedTabIndex : 0] = prepareReusablePTableLoadDataConfiguration(this.tableFilteredFields, this.otherService, this.router,
          this.areColumnFiltersEdited, this.isPaginationRequested, this.isSortingRequested, this.event);
        this.onCRUDRequested(CrudType.GET, this.returnRowObjectWithIndexKey(), null, true, false);
      }, 100);
    }
  }

  clearFilter() {
    this.columnFilterForm.reset();
    this.store.select(tableFilteredDataSelector$).pipe(take(1)).subscribe((tableFilteredData: any) => {
      if (!tableFilteredData) return;
      let tableFilteredFields: any = { ...tableFilteredData };
      tableFilteredFields = Object.assign({ saveFilter: false }, tableFilteredFields[this.otherService.currentUrl]);
      this.store.dispatch(new SharedTableFilteredDataCreated({ tableFilteredFields }));
    });
  }

  saveFilter() {
    // this.store.select(tableFilteredDataSelector$).pipe(take(1)).subscribe((tableFilteredData:any)=>{
    //   if(!tableFilteredData)return;
    //   let tableFilteredFields:any={...tableFilteredData};
    //   tableFilteredFields=Object.assign({saveFilter:true},tableFilteredFields[this.otherService.currentUrl]);
    //   this.store.dispatch(new SharedTableFilteredDataCreated({ tableFilteredFields }));
    // });
  }

  ngOnDestroy() {

  }

  // start logic table fields search persistant
  organizeRowVariableAsPerTabIndex() {
    if (!this.row?.[this.selectedTabIndex ? this.selectedTabIndex : 0]) {
      this.row[this.selectedTabIndex ? this.selectedTabIndex : 0] = {
        pageIndex: +CommonPaginationConfig.defaultPageIndex,
        pageSize: +CommonPaginationConfig.defaultPageSize
      };
    }
  }

  returnRowObjectWithIndexKey() {
    return this.row[this.selectedTabIndex ? this.selectedTabIndex : 0];
  }
  // end logic table fields search persistant

  ngAfterViewInit() {
    // this.scrollData = this.chatScrollBar?.nativeElement?.getElementsByClassName('ng-native-scrollbar-hider')[0];
    this.scrollTableHeaderData = this.table?.el?.nativeElement?.getElementsByClassName("ui-table-scrollable-header")[0];
    this.scrollTableBodyData = this.table?.el?.nativeElement?.getElementsByClassName("ui-table-scrollable-body")[0];
    this.onScrollTableScrollbar();
  }

  onScrollTableScrollbar() {
    // this.scrollTableHeaderData.onscroll = (x) => {
    // console.log('header scroll'+x.target);
    // if (this.dataList?.length == 0) {
    //   this.scrollTableBodyData.scrollLeft = this.scrollTableHeaderData.scrollLeft;
    // }
    // }
    // this.scrollTableBodyData.onscroll = (x) => {
    // console.log('body scroll'+x.target);
    // if (this.dataList?.length) {
    //   this.scrollTableHeaderData.scrollLeft = this.scrollTableBodyData.scrollLeft;
    // }
    // }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes?.tabsList?.currentValue != changes?.tabsList?.previousValue) {
      this.tabsList = this.tabsList;
      if (!changes?.selectedTabIndex) {
        this.columnFilterForm = this.tabsList?.length ? this.tableFilterFormService.createFormGroup(this.tabsList[this.selectedTabIndex]?.columns) : this.columnFilterForm;
        this.columnFilterRequest();
      }
    }
    // for refreshing the selections
    if ((changes?.loading?.currentValue != changes?.loading?.previousValue) ||
      (changes?.dataList?.currentValue != changes?.dataList?.previousValue)) {
      // this.selectedRows = [];
    }
    if (changes?.selectedRows?.currentValue != changes?.selectedRows?.previousValue) {
      this.selectedRows = changes?.selectedRows?.currentValue;
    }
    if (changes?.first?.currentValue == 0) {
      this.row[this.selectedTabIndex ? this.selectedTabIndex : 0] = { pageIndex: 0, pageSize: 10 };
    }
    if (changes?.reset?.currentValue == true) {
      this.resetSort();
    }
    if (changes?.clearSelectedRow?.currentValue == true) {
      this.selectedRows = [];
    }
    this.loading = this.loading;
    this.dataList = this.dataList;
    this.totalRecords = this.totalRecords;
    // if (changes?.selectedTabIndex?.currentValue != changes?.selectedTabIndex?.previousValue && changes?.selectedTabIndex?.currentValue) {// not working for tab change index 0 so remove that currentValue condition
    if (changes?.selectedTabIndex?.currentValue != changes?.selectedTabIndex?.previousValue) {
      if (!this.enableFieldValuesPersistance) {
        this.first = 0;
      }
      this.selectedRows = [];
      this.searchColumns = '';
      this.columnFilterForm = this.tabsList?.length ? this.tableFilterFormService.createFormGroup(this.tabsList[this.selectedTabIndex]?.columns) : this.columnFilterForm;
      this.columnFilterRequest();
    }
  }

  ngAfterViewChecked() {

  }

  ngAfterContentChecked() {
    if (this.enableFieldValuesPersistance) {
      if (Object.keys(this.returnRowObjectWithIndexKey() ? this.returnRowObjectWithIndexKey() : {}).length == 0 && this.table) {
        this.table.first = 0;
      }
      else if (this.table) {
        this.table.first = (this.returnRowObjectWithIndexKey()?.pageIndex * this.returnRowObjectWithIndexKey()?.pageSize);
      }
    }
  }

  transformDecimal(num?: number) {
    return this.otherService.transformDecimal(num)
  }

  getClass(rowData) {
    return rowData?.cssClass ? rowData['cssClass'] : '';
  }

  onSelectDate(rowData, index, event) {
    rowData['isChanged'] = true;
  }

  toggleMenu(menu, event, rowData) {
    this.menuItems.forEach((menuItem) => {
      menuItem.data = rowData;
    });
    menu.toggle(event);
  }

  onCRUDRequested(type: CrudType | string, data?: object, unknownVar?: number | string | any, shouldDispatchNgrxAction = true, shouldEmitEvent = true): void {
    switch (type) {
      case CrudType.CREATE:
        this.onActionSubmited.emit({ type, data });
        break;
      case CrudType.VIEW:
        this.onActionSubmited.emit({ type, data, col: unknownVar ? unknownVar : 0 });
        break;
      case CrudType.GET:
        if (this.enableFieldValuesPersistance) {
          let otherParams = {};
          if (this.searchForm.value.searchKeyword) {
            otherParams["search"] = this.searchForm.value.searchKeyword;
          }
          if (Object.keys(data ? data : {}).length > 0) {
            let dataCopy = { searchColumns: {} };
            // logic for split columns and its values to key value pair
            if (data['searchColumns']) {
              Object.keys(data['searchColumns']).forEach((key) => {
                const findRow = this.findTableRowDetail(key);
                if (findRow?.isDateTimeFilter) {
                  dataCopy['searchColumns'][key] = this.momentService.toRailwayDateTime(data['searchColumns'][key]);
                } else if (data['searchColumns'][key] instanceof Date) {
                  dataCopy['searchColumns'][key] = this.momentService.localToUTCDateTime(data['searchColumns'][key]);
                } else {
                  dataCopy['searchColumns'][key] = data['searchColumns'][key];
                }
              });
              data['searchColumns'] = dataCopy['searchColumns'];
            }
          }
          else {
            data = {
              pageIndex: +CommonPaginationConfig.defaultPageIndex,
              pageSize: +CommonPaginationConfig.defaultPageSize
            };
          }
          if (!data['pageIndex']?.toString()) {
            data = {
              ...data,
              pageIndex: +CommonPaginationConfig.defaultPageIndex,
              pageSize: +CommonPaginationConfig.defaultPageSize
            };
          }
          this.row[this.selectedTabIndex ? this.selectedTabIndex : 0] = data;
          let { rowObject, otherParamsObject } = createOrUpdateFilteredFieldKeyValues(this.tableFilteredFields, data, this.tabsList, this.otherService, this.store, shouldDispatchNgrxAction,
            this.areColumnFiltersEdited, this.isPaginationRequested, this.isSortingRequested);
          Object.keys(data).forEach((key) => {
            if (key == 'searchColumns') {
              delete data[key];
            }
          });
          data = { ...data, ...rowObject };
          otherParams = { ...otherParams, ...otherParamsObject };
          setTimeout(() => {
            if (shouldEmitEvent) {
              // To fetch the default sort by if any from the ngrx store
              if (otherParams?.['sortOrderColumn']) {
                this.tabsList[this.selectedTabIndex]['sortField'] = otherParams?.['sortOrderColumn'];
                this.tabsList[this.selectedTabIndex]['sortOrder'] = otherParams?.['sortOrder'] == 'ASC' ? 1 :
                  otherParams?.['sortOrder'] == 'DESC' ? -1 : 0;
              }
              if (this.isSortingRequested || this.areColumnFiltersEdited) {
                //   this.first = +CommonPaginationConfig.defaultPageIndex; // - Karthik -> We should not reset the pagination when do sorting or filter
                //   this.pageSize = +CommonPaginationConfig.defaultPageSize; //  Karthik -> We should not reset the pagination when do sorting or filter
                // }
                // else {
                this.first = (data?.['pageIndex'] * data?.['pageSize']);
              }
              this.onActionSubmited.emit({ type: type, data, search: otherParams });
            }
            this.pageSize = data?.['pageSize'] || +CommonPaginationConfig.defaultPageSize;

          });
          // end logic table fields search persistant
          break;
        }
        else {
          let otherParams = {};
          if (this.searchForm.value.searchKeyword) {
            otherParams["search"] = this.searchForm.value.searchKeyword;
          }
          if (Object.keys(this.row).length > 0) {
            // logic for split columns and its values to key value pair
            if (this.row['searchColumns']) {
              Object.keys(this.row['searchColumns']).forEach((key) => {
                if (this.row['searchColumns'][key] instanceof Date) {
                  const findRow = this.findTableRowDetail(key);
                  if (findRow?.isDateTimeFilter) {
                    otherParams[key] = this.momentService.toRailwayDateTime(this.row['searchColumns'][key]);
                  }
                  else if (findRow?.type == "primeng_timer" || key == "scheduledFrom" || key == "scheduledTo" || key == "testRunTime") {
                    otherParams[key] = this.momentService.toHoursMints24(this.row['searchColumns'][key]);
                  } else {
                    otherParams[key] = this.momentService.localToUTCDateTime(this.row['searchColumns'][key]);
                  }
                } else {
                  otherParams[key] = this.row['searchColumns'][key];
                }
              });
            }
            if (this.row['sortOrderColumn']) {
              otherParams['sortOrder'] = this.row['sortOrder'];
              otherParams['sortOrderColumn'] = this.row['sortOrderColumn'];
            }
          }
          this.onActionSubmited.emit({ type: type, data, search: otherParams });
        }
        break;
      case CrudType.EDIT:
        this.onActionSubmited.emit({ type, data, col: unknownVar ? unknownVar : 0 });
        break;
      case CrudType.ACTION:

        this.onActionSubmited.emit({ type, data, col: unknownVar ? unknownVar : 0 });
        break;
      case CrudType.STATUS_POPUP:
        this.onActionSubmited.emit({ type, data, col: unknownVar ? unknownVar : 0 });
        break;
      case CrudType.DELETE:
        this.onActionSubmited.emit({ type, data });
        break;
      case CrudType.QUANTITY_CLICK:
        this.onActionSubmited.emit({ type, data, search: unknownVar ? unknownVar : 0 });
        break;
      case CrudType.FLAG:
        this.onActionSubmited.emit({ type, data, search: unknownVar ? unknownVar : 0 });
        break;
      case CrudType.EDIT_ACTION:
        this.onActionSubmited.emit({ type, data, search: unknownVar ? unknownVar : 0 });
        break;
      case CrudType.CUSTOM_VIEW:
        this.onActionSubmited.emit({ type, data });
        break;
      case CrudType.CUSTOM_ASSIGN:
        this.onActionSubmited.emit({ type, data });
        break;
      case CrudType.CUSTOM_CANCEL:
        this.onActionSubmited.emit({ type, data });
        break;
      case CrudType.ROW_CHECKBOX:
        this.onActionSubmited.emit({ type, data, col: unknownVar ? unknownVar : 0 });
        break;
    }
  }

  searchKeywordRequest() {
    this.searchForm.valueChanges
      .pipe(
        debounceTime(debounceTimeForDeepNestedObjectSearchkeyword),
        distinctUntilChanged(),
        switchMap(val => {
          return of(this.onCRUDRequested(CrudType.GET, {}));
        })
      )
      .subscribe();
  }

  columnFilterRequest() {
    this.columnFilterForm.valueChanges
      .pipe(
        debounceTime(debounceTimeForDeepNestedObjectSearchkeyword),
        distinctUntilChanged(),
        switchMap(obj => {
          this.onScrollTableScrollbar();
          Object.keys(obj).forEach(key => {
            if (obj[key] === "") {
              delete obj[key]
            }
          });
          const filterRangeColumns = this.tabsList[this.selectedTabIndex]?.columns.filter(el => el?.type == 'primeng_range');
          filterRangeColumns?.forEach(el => {
            let dateConvertArray = [];
            obj[el?.field]?.forEach(el1 => {
              if (el1) {
                dateConvertArray.push(this.momentService.localToUTCDateTime(new Date(el1)));
              }
            });
            obj[el?.field] = dateConvertArray;
            if (!obj[el?.field]) {
              delete obj[el?.field]
            }
          });
          this.areColumnFiltersEdited = true;
          this.isPaginationRequested = false;
          this.isSortingRequested = false;
          this.searchColumns = Object.entries(obj).reduce((a, [k, v]) => (v == null ? a : (a[k] = v, a)), {}) //Filter all falsy values ( null, undefined )
          this.isSaveFilterBtnDisabled = Object.keys(this.searchColumns).length > 0 ? false : true;
          this.isClearFilterBtnDisabled = Object.keys(this.searchColumns).length > 0 ? false : true;
          let copyRow = { ...this.row[this.selectedTabIndex ? this.selectedTabIndex : 0] } // Karthik -> Taking copy of row for keep pagesize and pageIndex data
          if (this.enableFieldValuesPersistance) {
            // start logic table fields search persistant
            this.organizeRowVariableAsPerTabIndex();
            this.row[this.selectedTabIndex ? this.selectedTabIndex : 0] = prepareReusablePTableLoadDataConfiguration(this.tableFilteredFields, this.otherService, this.router,
              this.areColumnFiltersEdited, this.isPaginationRequested, this.isSortingRequested, null, this.searchColumns);
            this.row[this.selectedTabIndex ? this.selectedTabIndex : 0] = { ...this.row[this.selectedTabIndex ? this.selectedTabIndex : 0], pageIndex: copyRow?.pageIndex, pageSize: copyRow?.pageSize } // Setting pageIndex & pageSize data
            this.row[this.selectedTabIndex ? this.selectedTabIndex : 0] = { // Immanuel bug no 3589 start
              ...this.row[this.selectedTabIndex ? this.selectedTabIndex : 0],
              pageIndex: 0,
              pageSize: this.row[this.selectedTabIndex ? this.selectedTabIndex : 0]['pageSize'] || this.pageSize
            }// Immanuel bug no 3589 end
            return of(this.onCRUDRequested(CrudType.GET, this.returnRowObjectWithIndexKey(), null, true, false));
            // end logic table fields search persistant
          }
          else {
            this.row['searchColumns'] = this.searchColumns;
            this.row['pageIndex'] = this.searchFirst ? 0 : this.row['pageIndex'];
            if (this.tabsList[this.selectedTabIndex]?.isSaveFilter && this.searchColumns) {
              localStorage.setItem(this.tabsList[this.selectedTabIndex]?.storageKey, JSON.stringify(this.row));
            } else if (this.tabsList[this.selectedTabIndex]?.isSaveFilter && !this.searchColumns) {
              localStorage.removeItem(this.tabsList[this.selectedTabIndex]?.storageKey);
            }
            return of(this.onCRUDRequested(CrudType.GET, this.row));
          }
        })
      )
      .subscribe();
  }

  // start logic table fields search persistant
  loadPaginationLazy(event) {
    this.event = event;
    let findField;
    if (event?.sortField) {
      findField = this.tabsList[this.selectedTabIndex]?.columns.find(el => el?.field == event?.sortField);
      if (!findField) {
        return;
      }
    }
    if (!this.enableFieldValuesPersistance) {
      let row = {};
      this.first = event.first;
      row['pageIndex'] = event.first / event.rows;
      row["pageSize"] = event.rows;
      row["sortOrderColumn"] = event.sortField;
      row["sortOrder"] = event.sortOrder == 1 ? 'ASC' : 'DESC';
      row["searchColumns"] = this.searchColumns;
      this.row = row;
      this.onCRUDRequested(CrudType.GET, this.row);
    }
  }
  // end logic table fields search persistant

  resetSort() {
    this.row = { pageIndex: 0, pageSize: 10 };
    this.reset = false;
    this.searchColumns = '';
    this.columnFilterForm.reset('', { emitEvent: false });
    if (this.table) {
      this.table.sortOrder = 0;
      this.table.sortField = '';
      this.table._rows = this.pageSize; // for reset page size dropdown
      setTimeout(() => {
        this.table.reset();
        // this.columnFilterForm = this.tabsList?.length ? this.tableFilterFormService.createFormGroup(this.tabsList[this.selectedTabIndex]?.columns) : this.columnFilterForm;
        this.columnFilterRequest();
      }, 500);
    }
    if (this.enableFieldValuesPersistance) {
      this.onCRUDRequested(CrudType.GET)
    }
  }

  findTableRowDetail(key) {
    return this.tabsList[this.selectedTabIndex]?.columns?.find(el => el?.field?.toLowerCase() == key?.toLowerCase());
  }

  onRowSelect(e) {
    this.onSelectedRows.emit(this.selectedRows);
    this.onSelectRow.emit({ type: 'select', data: e?.data }); // To handle selection and deselection - in the old logic, we cannot determine whether it is a selection or a deselection.
  }

  onRowUnselect(e) {
    this.onSelectedRows.emit(this.selectedRows);
    this.onUnSelectRow.emit({ type: 'unselect', data: e?.data }); // To handle selection and deselection - in the old logic, we cannot determine whether it is a selection or a deselection.

  }

  onCheckboxChange(e) {
    this.onSelectedRows.emit(this.selectedRows);
  }

  onRowCheckboxChange(e, data, ri) {
    if (this.isSelectionOne && this.selectedRows?.length) {
      this.selectedRows = [data];
    }
    this.onCRUDRequested('row checkbox', data, ri);
  }

  exportExcel() {
    this.excelPrinted.emit();
  }

  onKeyUpInput(e, col, ri) {
    if (col?.isKeyup) {
      this.onCRUDRequested('action', e?.target?.value, { index: ri, column: col });
    }
  }

  onInputNumberWithDecimal(e, col, rowData) {
    if (col?.isInputRandSymbolRequired) {
      const input = e.target;
      let value = input.value;

      // Remove any non-numeric characters except decimal point
      value = value.replace(/[^0-9.]/g, '');

      // Ensure only one decimal point
      const parts = value.split('.');
      if (parts.length > 2) {
        value = parts[0] + '.' + parts.slice(1).join('');
      }

      // Limit to 2 decimal places
      if (parts.length === 2 && parts[1].length > 2) {
        value = parts[0] + '.' + parts[1].substring(0, 2);
      }

      // Ensure minimum value is 0 (remove negative signs)
      if (value.startsWith('-')) {
        value = value.replace('-', '');
      }

      // Enforce maximum value if defined
      if (col?.max && value !== '' && value !== '.') {
        const numValue = parseFloat(value);
        if (!isNaN(numValue) && numValue > col.max) {
          value = col.max.toString();
        }
      }

      // Update the input value
      input.value = value;
      rowData[col.field] = value === '' ? null : (value === '.' ? '0.' : value);
    }
  }

  onKeyPressNumberWithDecimal(e, col) {
    if (col?.isInputRandSymbolRequired) {
      const char = String.fromCharCode(e.which || e.keyCode);

      // Allow: backspace, delete, tab, escape, enter, decimal point
      if ([8, 9, 27, 13, 46, 110, 190].indexOf(e.keyCode || e.which) !== -1 ||
        // Allow: Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
        (e.keyCode === 65 && e.ctrlKey === true) ||
        (e.keyCode === 67 && e.ctrlKey === true) ||
        (e.keyCode === 86 && e.ctrlKey === true) ||
        (e.keyCode === 88 && e.ctrlKey === true) ||
        // Allow: home, end, left, right
        (e.keyCode >= 35 && e.keyCode <= 39)) {
        return;
      }

      // Ensure that it is a number or decimal point
      if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105) && e.keyCode !== 110 && e.keyCode !== 190) {
        e.preventDefault();
        return;
      }

      // Check if decimal point already exists
      const currentValue = e.target.value;
      if (char === '.' && currentValue.indexOf('.') !== -1) {
        e.preventDefault();
        return;
      }

      // Check decimal places limit
      if (currentValue.indexOf('.') !== -1) {
        const decimalPart = currentValue.split('.')[1];
        if (decimalPart && decimalPart.length >= 2) {
          e.preventDefault();
          return;
        }
      }

      // Check max value limit if defined
      if (col?.max) {
        const selectionStart = e.target.selectionStart;
        const selectionEnd = e.target.selectionEnd;
        const newValue = currentValue.substring(0, selectionStart) + char + currentValue.substring(selectionEnd);
        const numValue = parseFloat(newValue);
        if (!isNaN(numValue) && numValue > col.max) {
          e.preventDefault();
          return;
        }
      }
    }
  }

  onBlurNumberWithDecimal(e, col, rowData) {
    if (col?.isInputRandSymbolRequired) {
      const input = e.target;
      let value = input.value;

      // Handle edge cases - set to "0" if empty, null, or undefined
      if (value === '' || value === null || value === undefined || value.trim() === '') {
        value = '0.00';
      }
      // Remove leading/trailing decimal points
      else if (value === '.') {
        value = '0';
      } else if (value.endsWith('.')) {
        value = value.slice(0, -1);
      }

      // Ensure value is not negative
      const numValue = parseFloat(value);
      if (isNaN(numValue) || numValue < 0) {
        value = '0';
      } else {
        // Limit to 2 decimal places if more than 2 exist
        const parts = value.split('.');
        if (parts.length === 2 && parts[1].length > 2) {
          value = parts[0] + '.' + parts[1].substring(0, 2);
        }
        // Otherwise keep the original format (preserves user input like "5" or "5.1")

        // Enforce maximum value if defined
        if (col?.max && numValue > col.max) {
          value = col.max.toString();
        }
      }

      input.value = value;
      rowData[col.field] = value;
    }
  }

  onChangeStatus(rowData, ri) {
    this.onCRUDRequested('status popup', rowData, ri);
  }
  onEditAction(type, rowData, index) {
    this.onCRUDRequested('edit-action', rowData, { index: index, type: type });
  }
  onQuantityClick(type, rowData, index) {
    this.onCRUDRequested('quantity-click', rowData, { index: index, type: type });
  }
  onClickIcon(rowData, ri, col) {
    this.onCRUDRequested('flag', rowData, { index: ri, column: col });
  }
  onChangeMultiStatus(rowData, ri, col) {
    this.onCRUDRequested('status popup', rowData, { index: ri, field: col });
  }
  onChangeCheckbox(rowData, ri, col) {
    if (col?.isClick) {
      this.onCRUDRequested('action', rowData, { index: ri, column: col });
    }
  }
  onChangeSwitch(rowData, ri, col) {
    if (col?.isClick) {
      this.onCRUDRequested('action', rowData, { index: ri, column: col });
    }
  }
  cancelShowPopup(index: number, type: any) {
    if (type == 'enter') {
      this.showPickedOrdersPopup = true;
      this.selectedriIndex = index;
    }
    else {
      this.showPickedOrdersPopup = false;
      this.selectedriIndex = null;
    }
  }

  isRowSelected(rowData, disabledField, disableValue = true) {
    return rowData[disabledField] == disableValue;
  }

  isShowHideCalender(rowData, showHideField, showValue) {
    if (rowData) {
      return rowData[showHideField] == showValue;
    } else {
      return false;
    }
  }

  parseFloat(value: any): number {
    if (value === null || value === undefined || value === '') {
      return 0;
    }
    const parsed = parseFloat(value);
    return isNaN(parsed) ? 0 : parsed;
  }
}
